import { apiClient } from './api';

export type TrackEventProps = Record<string, unknown>;

export async function trackEvent(
  eventName: string,
  props?: TrackEventProps
): Promise<void> {
  try {
    await apiClient.post('/events/track', {
      eventName,
      props: props || {},
      source: 'web',
      referer: document.referrer || null,
      userId: null,
      brandId: (props && (props as any).brandId) || null,
    });
  } catch (e) {
    // 非关键路径，静默失败
    // eslint-disable-next-line no-console
    console.debug('trackEvent failed', e);
  }
}
